import { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Messages } from 'primereact/messages';
import { classNames } from 'primereact/utils';
import _css from './login.module.css';
import './login.css';
import { Card } from 'primereact/card';
import portalLogo from "../../assets/Images/teklense-logo-lg.jpg";
import { Fetch } from '../../utilities/fetch';
import { ILogin, useAuth } from '../../hooks/useAuth';
import { TDropdown } from '../../shared/modal';
import { ProgressSpinner } from 'primereact/progressspinner';

interface IFormInputs {
    email: string
    password: string
}

type TTryLoginResponse = {
    requiresCompanySelection: boolean,
    company: TDropdown
    companies: TDropdown[]
}

const schema = yup.object({
    email: yup.string().required("Email is required*"),
    password: yup.string().required("Password is required*"),
});

export const Login = () => {
    const { login } = useAuth();
    const message = useRef<any>(null);
    const [companiesSelection, setCompaniesSelection] = useState<{ tryLogin: TTryLoginResponse, data: IFormInputs }>();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, setFocus } = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (!loading) {
            const form = document.querySelector('form');
            form?.classList.add('invalid_details');
            setTimeout(() => {
                form?.classList.remove('invalid_details');
            }, 550);
        }
    }, [loading]);

    useEffect(() => {
        setFocus("email");
    }, [setFocus]);

    async function autoLoginWithCompany(companyId: number, data: IFormInputs) {
        const res = await Fetch<ILogin>("Auth/login", { method: "POST", body: data, query: `companyId=${companyId}` });
        if (res) login(res);
    }

    async function loginWithCompany(companyId: number, data: IFormInputs) {
        if (loading) return;
        setLoading(true);
        const res = await Fetch<ILogin>("Auth/login", { method: "POST", body: data, query: `companyId=${companyId}` });
        if (res) login(res);
        setLoading(false);
    }

    async function onSubmitLogin(data: IFormInputs) {
        if (loading) return;
        setLoading(true);
        const res = await Fetch<TTryLoginResponse>("Auth/try-login", { method: "POST", body: data, });
        if (res) {
            // if (res.requiresCompanySelection) {
            setCompaniesSelection({ tryLogin: { ...res, companies: [res.company] }, data });
            // }
            // else if (res.company.id) {
            //     await autoLoginWithCompany(res.company.id, data);
            // }
        }
        setLoading(false);
    }

    return (
        <div className="login-body">
            <div className="login-wrapper">
                <div className="login-panel">
                    <img src={portalLogo} width={388} alt="jobvritta" />
                    <form onSubmit={handleSubmit(onSubmitLogin)} className="col-12">
                        <Card className="">
                            <h5>Login</h5>
                            <Messages ref={message} />
                            <div className="grid p-fluid">
                                {companiesSelection ? (<div className="col-12">
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '10px',
                                        }}
                                    >
                                        {companiesSelection.tryLogin.companies.map(c => (
                                            <div
                                                key={c.id}
                                                className="cursor-pointer"
                                                onClick={async () =>
                                                    loginWithCompany(c.id, companiesSelection.data)
                                                }
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '14px 16px',
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: '10px',
                                                    background: '#fff',
                                                    transition: 'all 0.15s ease',
                                                    cursor: 'pointer',
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.borderColor = '#93c5fd';
                                                    e.currentTarget.style.background = '#f8fbff';
                                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.borderColor = '#e2e8f0';
                                                    e.currentTarget.style.background = '#fff';
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '12px',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    {/* Company icon */}
                                                    <div
                                                        style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            minWidth: '40px',
                                                            borderRadius: '8px',
                                                            background: '#eff6ff',
                                                            color: '#2563eb',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '18px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {c.name?.charAt(0)?.toUpperCase()}
                                                    </div>

                                                    {/* Company name */}
                                                    <div style={{ minWidth: 0 }}>
                                                        <div
                                                            style={{
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                color: '#1e293b',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {c.name}
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontSize: '11px',
                                                                color: '#94a3b8',
                                                                marginTop: '2px',
                                                            }}
                                                        >
                                                            Select company to continue
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Arrow */}
                                                {loading ? <ProgressSpinner style={{ display: 'inline-block', width: '20px', height: '20px' }} />
                                                    : <i className="pi pi-chevron-right" style={{ color: '#94a3b8', fontSize: '12px', }} />}
                                            </div>
                                        ))}
                                    </div>
                                </div>) : (<>
                                    <div className="col-12 md:col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-user"></i>
                                            </span>
                                            <Controller name='email' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                                <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} placeholder="Email" />
                                            )} />
                                        </div>
                                    </div>
                                    <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.email?.message}</small>
                                    <div className="col-12 md:col-12">
                                        <div className="p-inputgroup">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-lock"></i>
                                            </span>
                                            <Controller name='password' control={control} defaultValue={''} render={({ field, fieldState }) => (
                                                <InputText {...field} className={classNames({ 'p-invalid': fieldState.invalid })} type="password" placeholder="Password" />
                                            )} />
                                        </div>
                                    </div>
                                    <small className="p-error" style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}>{errors.password?.message}</small>
                                    <div className="col-12 md:col-12">
                                        <Button label="LOGIN" type="submit" loading={loading}></Button>
                                    </div>
                                </>)}
                            </div>
                        </Card>
                    </form>
                    <p></p>
                </div>
                {/* <div className={`login-image ${_css.wrapper}`}>
                    <h1>Access to your <span style={{ color: '#05A7E0' }}>Job</span><span style={{ color: '#EA6E27' }}>Vritta</span> Account</h1>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                    <div><span className={_css.dot}>JOB</span></div>
                </div> */}
                <div className="login-image">
                    <div className={`login-image-content ${_css.container}`} style={{ marginTop: "3vh" }}>
                        <h1>Access to your</h1>
                        <h1>TEKLense</h1>
                        <h1>Account</h1>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
};
